<section class="mt-50">
	<lbca-date-picker
		[label]="'Data prazo'"
		[value]="dateDue"
		[rules]="rules"
		[disabledDateRules]="disabledDateRules"
		[max]="_dateDueFatal"
		(changeValue)="changeDate($event)"
	></lbca-date-picker>
</section>
